import styled from 'styled-components';

export const InfoIconOuterContainerStyled = styled.div`
  width: 80px;
  height: 80px;
  border-width: 4px;
  border-style: solid;
  border-color: rgb(70, 184, 218);
  border-radius: 50%;
  position: relative;
  box-sizing: content-box;
`;

export const InfoIconHeadDotStyled = styled.div`
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  margin-left: -3px;
  left: 50%;
  top: 19px;
  background-color: rgb(91, 192, 222);
`;

export const InfoIconStraightLineStyled = styled.div`
  position: absolute;
  width: 5px;
  height: 29px;
  left: 50%;
  bottom: 17px;
  border-radius: 2px;
  margin-left: -2px;
  background-color: rgb(91, 192, 222);
`;

export const FooterStyled = styled.div`
  display: flex;
  z-index: 1;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 1.25em auto 0px;
`;

export const ConfirmButtonStyled = styled.a`
  margin-right: 8px;
`;

export const CancelButtonStyled = styled.a`
  margin-right: 8px;
  border-color: rgb(40, 96, 144);
  box-shadow: rgba(0, 0, 0, 0.075) 0px 1px 1px inset, rgb(165, 202, 234) 0px 0px 8px;
`;
